import React from 'react';
import PropTypes from 'prop-types';
import Box from 'common/src/components/Box';
import Text from 'common/src/components/Text';
import Heading from 'common/src/components/Heading';
import Container from 'common/src/components/UI/Container';
import TiltShape from '../TiltShape';
import { BannerWrapper } from './banner.style';
import Button from '../../../../common/src/components/Button';

const BannerSectionSmall = ({
  row,
  contentWrapper,
  titleWrapper,
  title,
  titleText,
  buttonLink,
  buttonLinkTarget,
  buttonText,
  description,
  descriptionText,
  imageWrapper,
  fillButton,
  buttonWrapper,
  image,
}) => {
  return (
    <BannerWrapper id="banner_section">
      <TiltShape />
      <Container>
        <Box {...row}>
          <Box {...contentWrapper}>
            {/*<Heading {...title} content={titleText} as="h1" />*/}
            {/*<Text {...description} content={descriptionText} />*/}
            {/*{buttonLink && (*/}
            {/*  <Box {...buttonWrapper}>*/}
            {/*    <a href={buttonLink} target={buttonLinkTarget} rel="noreferrer">*/}
            {/*      <Button {...fillButton} title={buttonText} />*/}
            {/*    </a>*/}
            {/*  </Box>*/}
            {/*)}*/}
          </Box>
        </Box>
        <Box {...row}>
          <Box {...titleWrapper}>
            <Heading {...title} content={titleText} as="h1" />
            <Text {...description} content={descriptionText} />
            {buttonLink && (
              <Box {...buttonWrapper}>
                <a href={buttonLink} target={buttonLinkTarget} rel="noreferrer">
                  <Button {...fillButton} title={buttonText} />
                </a>
              </Box>
            )}
          </Box>
        </Box>
      </Container>
    </BannerWrapper>
  );
};

BannerSectionSmall.propTypes = {
  row: PropTypes.object,
  contentWrapper: PropTypes.object,
  titleWrapper: PropTypes.object,
  discountAmount: PropTypes.object,
  discountText: PropTypes.object,
  title: PropTypes.object,
  titleText: PropTypes.string,
  buttonLink: PropTypes.string,
  buttonLinkTarget: PropTypes.string,
  buttonText: PropTypes.string,
  description: PropTypes.object,
  descriptionText: PropTypes.string,
  imageWrapper: PropTypes.object,
  buttonWrapper: PropTypes.object,
  button: PropTypes.object,
  fillButton: PropTypes.object,
  image: PropTypes.object,
};

BannerSectionSmall.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentWrapper: {
    width: ['100%', '100%', '80%', '55%', '50%'],
    mb: '40px',
    // backgroundColor: 'rgba(0,0,0,0.3)',
    padding: '20px',
  },
  titleWrapper: {
    backgroundColor: 'rgba(255,255,255,0.3)',
    padding: '20px',
  },
  imageWrapper: {
    width: '100%',
  },
  title: {
    fontSize: ['24px', '32px', '40px', '42px', '46px'],
    fontWeight: '700',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: ['20px', '25px', '25px', '25px', '25px'],
    lineHeight: '1.2',
    textAlign: 'center',
  },
  description: {
    fontSize: ['15px', '16px', '16px', '16px', '16px'],
    color: '#0f2137',
    lineHeight: '1.75',
    mb: '0',
    textAlign: 'center',
  },
  discountAmount: {
    fontSize: ['13px', '14px', '14px', '14px', '14px'],
    fontWeight: '700',
    color: '#00865b',
    mb: 0,
    as: 'span',
    mr: '0.4em',
  },
  discountText: {
    fontSize: ['13px', '14px', '14px', '14px', '14px'],
    fontWeight: '700',
    color: '#fff',
    mb: 0,
    as: 'span',
  },
  fillButton: {
    type: 'button',
    fontSize: ['13px', '14px'],
    fontWeight: '600',
    borderRadius: '4px',
    p: ['0px 15px', '8px 22px'],
    colors: 'secondaryWithBg',
    minWidth: ['auto', '150px'],
    height: ['40px', '46px'],
    minHeight: 'auto',
  },
  buttonWrapper: {
    flexBox: true,
    justifyContent: 'center',
    mt: '35px',
  },
  button: {
    type: 'button',
    fontSize: ['13px', '14px'],
    fontWeight: '600',
    borderRadius: '4px',
    p: ['0px 15px', '8px 22px'],
    color: '#fff',
    colors: 'secondary',
    height: ['40px', '46px'],
    minHeight: 'auto',
  },
  buttonLinkTarget: '_blank',
};

export default BannerSectionSmall;
